var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-md"},[_c('Breadcrumbs',{attrs:{"current":"Reports"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }